var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAtSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.0005C0.001 17.0655 4.936 22.0005 11.001 22.0005C13.405 21.9995 15.78 21.1945 17.688 19.7335C18.127 19.3975 18.21 18.7715 17.874 18.3325C17.54 17.8945 16.91 17.8115 16.473 18.1465C14.911 19.3415 12.968 19.9995 11.001 20.0005C6.038 20.0005 2.001 15.9635 2 11.0005C2 8.59649 2.936 6.33649 4.636 4.63649C6.335 2.93649 8.596 2.00049 11 2.00049C15.962 2.00049 20 6.03749 20 10.9995V11.9995C20 13.1025 19.103 13.9995 18 13.9995C16.897 13.9995 16 13.1025 16 11.9995V10.9995C16 8.24249 13.757 5.99949 11 5.99949C8.243 5.99949 6 8.24249 6 10.9995C6 13.7565 8.243 15.9995 11 15.9995C12.4862 15.9995 13.8231 15.3477 14.7397 14.3149C15.4654 15.3338 16.6563 15.9995 18 15.9995C20.206 15.9995 22 14.2055 22 11.9995V10.9995C22 4.93449 17.065 0.000488281 11 0.000488281C8.061 0.000488281 5.299 1.14449 3.221 3.22249C1.144 5.30049 0 8.06249 0 11.0005ZM14 10.9995C14 9.34549 12.654 7.99949 11 7.99949C9.346 7.99949 8 9.34549 8 10.9995C8 12.6535 9.346 13.9995 11 13.9995C12.654 13.9995 14 12.6535 14 10.9995Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtSign);
export default __webpack_public_path__ + "static/media/Icon-At-Sign.12bec299898f5fcee2d8b6cc2c0dbcb1.svg";
export { ForwardRef as ReactComponent };